module.exports = __webpack_public_path__ + "static/img/rank_315.932d270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank_315.png
// module id = KYW0
// module chunks = 0